<template>
    <div class="search-select">
        <a-form layout="horizontal" class="form-box">
            <div class='fold'>
                <a-row type="flex" justify="start">
                    <a-col
                        v-for="(item, index) in options" :key="index"
                        :lg="item.size ? parseInt(lg*item.size) : lg"
                        :xl="item.size ? parseInt(xl*item.size) : xl"
                        :xxl="item.size ? parseInt(xxl*item.size) : xxl"
                        :md="item.size ? parseInt(md*item.size) : md"
                        :xs="item.size ? parseInt(xs*item.size) : xs">
                        <a-form-item
                            :key="item.label+item.key+index"
                            :labelCol="{span: labelCol}"
                            :wrapperCol="{span: wrapperCol}"
                            :label="item.label"
                        >
                            <template v-if="item.type == 'text'">
                                <a-input allow-clear class="select-flex" :placeholder="item.placeholder" v-model="item.data"/>
                            </template>
                            <!-- 多行文本框 -->
                            <template v-else-if="item.type == 'textarea'">
                                <a-textarea :placeholder="item.placeholder" auto-size v-model="item.data" />
                            </template>
                            <!-- type == 'select' 下拉框 -->
                            <template v-else-if="item.type == 'select'">
                                <a-select v-model="item.data" show-search :placeholder="item.placeholder" allowClear :getPopupContainer="e => {return e.parentNode || document.body}">
                                    <a-select-option :value="k.value" v-for="(k, j) in item.option" :key="item.key + j">{{k.label}}</a-select-option>
                                </a-select>
                            </template>
                            <template v-else-if="item.type == 'treeSelect'">
                                <a-tree-select 
                                    :tree-data="item.treeData"
                                    v-model="item.data"
                                    :placeholder="item.placeholder"
                                    treeDefaultExpandAll
                                    :replace-fields="item.replaceFields"
                                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                />
                            </template>
                            <!-- type == 'time' 单个选择时间框 -->
                            <template v-else-if="item.type == 'time'">
                                <a-date-picker class="select-flex"
                                    :disabledDate="item.disabledDate"
                                    showTime
                                    :format="item.format"
                                    v-model="item.data"
                                />
                            </template>
                            <!-- type == 'times' 多个选择时间框 -->
                            <template v-else-if="item.type == 'times'">
                                <a-range-picker class="select-flex"
                                    v-model="item.data"
                                    format="YYYY-MM-DD HH:mm:ss"
                                    :disabledDate="item.noDisabledDate ? '': disabledDateFun"
                                    :default-value="[moment().startOf('day'), moment().startOf('day').add(1, 'days')]"
                                ></a-range-picker>
                            </template>
                        </a-form-item>
                    </a-col>
                    <a-col :md="btnSize" :sm="24">
                        <slot name="selectSlot"></slot>
                        <a-form-item>
                            <slot name="submitBtn">
                                <a-button type="primary" @click="handleSearch">{{$t('btn.search')}}</a-button>
                                <a-button style="margin-left: 8px" @click="handleReset">{{$t('btn.reset')}}</a-button>
                            </slot>
                            <slot name="selectBtnAfterSlot"></slot>
                        </a-form-item>
                    </a-col>

                </a-row>
            </div>
        </a-form>
        <div class="btn-box" v-if="showBtn">
            <slot name="addBtn"></slot>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    export default {
        name:'searchSelect',
        data () {
            return {
                selectData: {}, //筛选后的数据
                isSelect: false, //是否展开搜索框
                indexLength: 2,
                labelCol: 4,
                wrapperCol: 6
            }
        },
        props: {
            xs: {
                type: Number,
                default: 12
            },
            md: {
                type: Number,
                default: 12
            },
            lg: {
                type: Number,
                default: 12
            },
            xl: {
                type: Number,
                default: 8
            },
            xxl: {
                type: Number,
                default: 6
            },
            btnSize: {
                type: Number,
                default: 6
            },
            options: Array, // 删选显示数据

            labelWidth: { //页面自定义label宽度
                type: Number,
                default: 115
            },
            showBtn: { //是否显示新增按钮
                type: Boolean,
                default: true
            },

        },
        created () {
            this.createdHeight ()
            //支持回车查询
            var self = this;
            document.onkeydown = function(e) {
                var key = window.event.keyCode;
                if (key == 13) {
                    self.handleSearch ()
                }
            }
            
			let locale = this.$cookieStore.getCookie("languageType") == "zh"

            this.labelCol = locale ? 7 : 8
            this.wrapperCol = locale ? 15 : 14
            
        },
        activated () {
            //支持回车查询
            var self = this;
            document.onkeydown = function(e) {
                var key = window.event.keyCode;
                if (key == 13) {
                    self.handleSearch ()
                }
            }
        },
        methods: {
            createdHeight () {
                if (document.body.clientWidth > 1600) {
                    this.indexLength = 5
                } else if (document.body.clientWidth > 1300) {
                    this.indexLength = 3
                } else {
                    this.indexLength = 2
                }
            },
            handleSearch () {
                this.selectData = {}
                if (this.options) {
                    for (let item of this.options) {
                        this.selectData[item.key] = item.data
                    }
                }
                
                this.$emit ("handleSearch", this.selectData)
            },
            handleReset () {
                for (let item of this.options) {
                    if(item.type == 'times'){
                        item.data = [moment().startOf('day'), moment().startOf('day').add(1, 'days')]
                    }else{
                        item.data = ""
                    }
                }
                this.$emit ("handleSearch", 'reset')
            },
            moment,
            disabledDateFun (current) {
                return current && current > moment().endOf('day');
            }
        }
    }
</script>
<style lang="scss" scoped>
.search-select {
    display: flex;
    .form-box {
        flex: 1;
    }
    .fold {
        margin-bottom: 17px;
    }
    ::v-deep .ant-row.ant-form-item {
        margin-bottom: 7px;
    }
    .btn-box {
        // width: 200px;
        text-align: right;
    }
}
</style>

